// extracted by css-extract-rspack-plugin
export default {"modalContent":"modalContent-jT7tnO","header":"header-zd6WU4","headerButtons":"headerButtons-vySm_q","content":"content-XUvTXV","footer":"footer-a0UhLl"};